
import { CellStyle } from "xlsx-js-style";
import { Row, Rows } from "../../../interfaces";
import { withCellStyles } from "../../../utils";
import { BmTemplateInternals, BudgetModalTemplateCurrentState } from "../budget-helper-internal";
import { leftIntendNoBold, textBold } from "../../../excelStyles";
import { BudgetModelFormGroup } from "../../../../models/budget-model/pojo/bm-form";
import { BmItemValue } from "../../../../models/budget-model/pojo/bm-classes-values";
import { BmDataFillingType } from "../../../../models/budget-model/pojo/bm-enums";

export class OperatingExpensesSection {
  constructor(
    private readonly budgetForm: BudgetModelFormGroup,
    private readonly helper: BmTemplateInternals,
  ) { }

  fillOperatingExpensesRows(rows: Rows, current: BudgetModalTemplateCurrentState): void {
    this.prepareOperatingExpensesMainRow(rows, current);
    this.prepareOperatingExpensesInternal(rows, current);
  }

  private prepareOperatingExpensesMainRow(newData: Rows, current: BudgetModalTemplateCurrentState): void {
    const operatingExpensesTotalRow: Row = [];
    operatingExpensesTotalRow.push(withCellStyles('Operating Expenses', textBold));
    const operatingExpensesTotal = this.budgetForm.controls.modelData.controls.operatingExpenses.value.total;
    const operatingExpensesTotalUpdated = this.helper.setNullToDataAfterYearForBmItems(operatingExpensesTotal as BmItemValue[], true);
    operatingExpensesTotalUpdated.forEach((value, index) => {
      // skip first name column
      if (index === 0) {
        return;
      }
      this.helper.pushSumOrValueWIthOutZeroIndex(operatingExpensesTotalRow, index, value, current.rowIndex, true);
    });

    this.helper.pushYearsTotalCellBold(operatingExpensesTotalRow, current.rowIndex, current.yearsIndexArray);
    this.helper.prepareCellForTotalPcnt(operatingExpensesTotalRow, current, true);
    this.helper.setCellForTotalPcntOfCommitment(operatingExpensesTotalRow, current.rowIndex, current.indexOfTotalColumn, true);
    newData.push(operatingExpensesTotalRow);
    current.indexArrayForTotalExpenses.push(current.rowIndex);
    current.rowIndex++;
  }

  private prepareOperatingExpensesInternal(newData: Rows, current: BudgetModalTemplateCurrentState): void {
    this.budgetForm.controls.modelData.controls.operatingExpenses.value.groups.forEach((operatingGroup) => {
      let operatingSubGroupRow: Row = [];
      operatingSubGroupRow.push(withCellStyles(operatingGroup.name, leftIntendNoBold as CellStyle));
      const type = operatingGroup.dataFillingType;
      const separatedArr = this.helper.separateArrByYear(operatingGroup.items);
      const operGroupItemsUpdated = this.helper.setNullToDataAfterYearForBmItems(operatingGroup.items as BmItemValue[], false);
      if (operatingGroup.dataFillingType === BmDataFillingType.YEARLY) {
        const yearStandardValue = operatingGroup.standardValue;
        operatingSubGroupRow = this.helper.buildOperatingSubGroupRowForAnnualPeriodType(separatedArr, yearStandardValue, operatingSubGroupRow, current.rowIndex);
      } else {
        operGroupItemsUpdated.forEach((operatingItem, itemIndex) => {
          const countedValue = this.helper.defineTypeOfCountingExpenses(operatingGroup.standardValue, type);
          if (operatingItem) {
            operatingItem.itemValue = operatingItem.itemValue ?? countedValue;
          }
          this.helper.pushSumOrValueWithZeroIndex(operatingSubGroupRow, itemIndex, operatingItem, current.rowIndex);
        });
      }

      this.helper.pushYearsTotalCellGray(operatingSubGroupRow, current.rowIndex, current.yearsIndexArray);
      this.helper.prepareCellForTotalPcnt(operatingSubGroupRow, current);
      this.helper.setCellForTotalPcntOfCommitment(operatingSubGroupRow, current.rowIndex, current.indexOfTotalColumn, true);
      newData.push(operatingSubGroupRow);
      current.rowIndex++;
    });
  }
}
